import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext';

const LocationSlideTwo= () => {

    const {retrive} = useContext(AppContext);
    const {slideIndex} = useContext(AppContext);

    const [ retreivealMarker ] = retrive;

    const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

    let starsArray = [];

    const loopThrought = (param) => {
        for (let i =0; i < param; i++ ) {
            starsArray.push(i);
        }
    }

       

  return (
    <div className="location_info">

    <div className="main_image slide_main_div"  >

 

        <div className="content-main-image">

            

            <h1 className="headline_location">  {retreivealMarker.name}  </h1>
            <div className="mt-2"></div>
            <h1 className="subheadline_location">نوع المكان : <span className="span_location">
                {retreivealMarker.category == "event" && "فعالية"}
                {retreivealMarker.category == "public_place" && "مكان عام"}
                {retreivealMarker.category == "tourist" && "منتجع سياحي"}
                {retreivealMarker.category == "coffee" && "كوفيه"}
                {retreivealMarker.category == "restaurant" && "مطعم"}
            </span></h1>
        <div className="mt-2"></div>
            <div className="d-flex-c stars_location mt-1">
            {loopThrought(retreivealMarker.stars)}
            {starsArray && starsArray.map(( ) => (
                <img src="/images/icons/star.png" alt="" className="star_icon_small" />
            ))}
                
                
            </div>

        <div className="mt-3"></div>
            <div className="d-flex-c f-sv items_images">

            {retreivealMarker.photos && retreivealMarker.photos.map((item) =>   (
                <div className="single_card_div_slideone">
                <img src={item} alt="" className="" />
                </div>
            ))}



             
             

              
            </div>

            <div className="blur_box_location mt-1">

                <div className="d-flex-c f-sv div_blur ">

{/* 
                    <div className='text-center' >
                    <div className="single_info_blur">
                        <img src="/images/icons/triangle.png" alt="" className="" />
                      
                    </div>
                    <p className="blur_info">مفتوح</p>
                    </div> */}

                    <div className='text-center' >
                    <div className="single_info_blur">
                        <img src="/images/icons/pin.png" alt="" className="" />
                       
                    </div>
                    <p className="blur_info" >   { retreivealMarker.location } </p>
                    </div>


                    <div className="single_info_blur">
                        <button className="btn_explore">اكتشف المزيد</button>
                    </div>
                    

                </div>



            </div>

            <div className="f-sv d-flex-c sliding_btns">
              <button className="btn_category bg_red " onClick={() => setIndexSlideValue(indexSlideValue - 1) } > السابق </button>
                <button className="btn_category bg_green" onClick={() => setIndexSlideValue( indexSlideValue + 1) } > التالي </button>
              </div>

        </div>
    </div>
   

    </div>
  )
}

export default LocationSlideTwo